import React from 'react';
import { LuiMultiSelect } from '@jda/lui-common-component-library-mui5';
import { useStyles } from './styles';

const LuiMultiSelectCustom = (props: any) => {
  const { classes } = useStyles();
  return (
    <LuiMultiSelect
      {...props}
      id={props.customId}
      data-testid={props.customId}
      className={props.className || classes.multiSelect}
      width={props.width || '100%'}
      disabled={props.disabled || false}
      maxHeight={props.maxHeight || '100%'}
    />
  );
};

export default LuiMultiSelectCustom;